// 获取滚动条的展示宽度
import { createNode, removeNode } from './dom';
import detect from './UADetect';
const os = detect.os;

const MEASURE_STYLE = {
	position: 'absolute',
	top: '-9999px',
	width: '50px',
	height: '50px',
	overflow: 'scroll',
};

export const SCROLL_WIDTH = (() => {
	if (os.phone) {
		return 0;
	}

	const scrollDiv = createNode(document.body, 'div');
	Object.assign(scrollDiv.style, MEASURE_STYLE);
	const scrollbarWidth =
		scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	removeNode(scrollDiv);

	return scrollbarWidth;
})();
